export const GET_CHANNEL_PARTNER_LISTING = "GET_CHANNEL_PARTNER_LISTING";
export const TRANSFER_HANDOVER_TO_CHANNEL_PARTNER = "TRANSFER_HANDOVER_TO_CHANNEL_PARTNER";
export const GET_CONTRACTS_BY_CHANNEL_PARTNER = "GET_CONTRACTS_BY_CHANNEL_PARTNER";
export const INVOICE_VISIBILITY_FOR_CHANNEL_PARTNER = "INVOICE_VISIBILITY_FOR_CHANNEL_PARTNER";
